/*
 *  DesertLandscaping INIT
 *  @author: jd@cals.arizona.edu
 *  @lastModified: Oct 2018
 */
import { Utils } from './cals.utils';
// import { App as DlApp } from './desertland.app';
// console.log('DESERTLAND.init');

export{};
declare global {
    interface Window {
        log: any;
        info: any;
        warn: any;
        error: any;
        group: any;
        groupCollapsed: any;
        groupEnd: any;
        time: any;
        timeEnd: any;
    }
}

// namespace
export const DESERTLAND: any = {
    VERSION: process.env.VERSION, //"2.0-alpha-201810",
    credits: "CALS CCT WebDev @ UA",
    
    // utils: Utils,
    // defaults:
    // currentPage : "", // moved to App
    // shareUrl : "" // moved to App
}; 


export const Config: any = {
    prodPath: "https://desertlandscaping.arizona.edu/",
    siteEmail: "webdev@cals.arizona.edu",
    appName: 'desertlandscaping',//for api.cals/mailer.php 
    features: {
        enableBasket: false,
        enableTrivia: false, // note that code needs to be refactored if we want this to work again
    },
    showLogs : {
        //debug 
        templates : true    
    },
    plants : {
        listPageSize : 12, // # of items to return per page
    },
    img_path : {
        hero : "webservice/sites/desertlandscaping.arizona.edu.webservice/files/hero/",
        plant : "webservice/sites/desertlandscaping.arizona.edu.webservice/files/plant/",
        resource : "webservice/sites/desertlandscaping.arizona.edu.webservice/files/resource_images/",
        quiz : "webservice/sites/desertlandscaping.arizona.edu.webservice/files/quiz_images/",
        tips : "webservice/sites/desertlandscaping.arizona.edu.webservice/files/field/image/",
        ideas: "webservice/sites/desertlandscaping.arizona.edu.webservice/files/landscape/",
        invasive: "webservice/sites/desertlandscaping.arizona.edu.webservice/files/invasive/"
    },
    json : {
        //useLocalDevData : false
        useLocalDevData : true
    } 
};

Config.img_url = {
    hero : Config.prodPath + Config.img_path.hero,
    plant : Config.prodPath + Config.img_path.plant,//"https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/files/plant/",
    resource : Config.prodPath + Config.img_path.resource,//"https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/files/resource_images/",
    quiz : Config.prodPath + Config.img_path.quiz,//"https://desertlandscaping.arizona.edu/webservice/sites/desertlandscaping.arizona.edu.webservice/files/quiz_images/"
    tips : Config.prodPath + Config.img_path.tips,
    ideas : Config.prodPath + Config.img_path.ideas,
    invasive : Config.prodPath + Config.img_path.invasive
};

Config.json.endpoint = (function(dev) {
    //auto executing function to determine this once then store the string
    
    let jsonPath = "webservice/sites/desertlandscaping.arizona.edu.webservice/json/";
    
    try {
        if (dev && document && document.location && document.location.hostname === "localhost") {
            console.log("%c[ using local dev json ]","color:#990000;font-style:italic;");
            jsonPath = "json/";
        } 
    } catch(err) {
        console.info("Error while trying to determine document.location.hostname - using default.");
    // } finally {
    }    
    return jsonPath;
}(Config.json.useLocalDevData));

DESERTLAND.config = Config;


// Avoid `console` errors in browsers that lack a console.
(function() {
    let method;
    const noop = function () {};
    const methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    let length = methods.length;
    const console:any = (window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());



window.log = console.log.bind(console);
window.info = console.info.bind(console);
window.warn = console.warn.bind(console);
window.error = console.error.bind(console);
window.group = console.group.bind(console);
window.groupCollapsed = console.groupCollapsed.bind(console);
window.groupEnd = console.groupEnd.bind(console);
window.time = console.time.bind(console);
window.timeEnd = console.timeEnd.bind(console);


console.log("%cWelcome to Desert Landscaping! %c(v%s) %cCreated by UA CALS CCT WebDev [ https://cct.cals.arizona.edu ]","color:blue;font-size:140%;font-weight:bold;","color:blue;font-size:100%;font-weight:normal;",DESERTLAND.VERSION,"color:green;font-size:100%;");
console.log("%cWe hope you enjoy using the site, let us know if you have any feedback or recommendations - cheers!","color:#8C7A64;font-size:100%;");





// set globals

(function() {
     // do it once
     DESERTLAND.site_root = Utils.strEndsWithSlash(Utils.getBaseURL());
    //  console.log("DESERTLAND.site_root:",DESERTLAND.site_root);
})();

export const SiteRoot = DESERTLAND.site_root;

// window.isEmpty = Utils.isEmpty;

// window.DESERTLAND = DESERTLAND;
// export default DESERTLAND;
